export default function validarFormLicencia(valores) {
    let errores = {};
    if(!valores.actividad){
        errores.actividad = 'La actividad es requerida'
    }

    return errores;
}